<template>
<v-container v-if="bookingContext">

    <BookingHeader :bookingContext="bookingContext"/>

    <v-row>

      <v-col cols="12" sm="12">
          <v-form @submit.prevent="validateAndSubmit" :disabled="isLoading">

            <div class="columns is-multiline is-centered box ">
              <div class="column is-full">

                <div style="display:flex; margin:-1.2rem 0 1.2rem;">
                  <i class="h-icon" :style="{'background-image': 'url(pay-icons/cb.jpg)'}"></i>
                  <i class="h-icon" :style="{'background-image': 'url(pay-icons/1.png)'}"></i>
                  <i class="h-icon" :style="{'background-image': 'url(pay-icons/2.png)'}"></i>
                  <i class="h-icon" :style="{'background-image': 'url(pay-icons/3.png)'}"></i>
                  <i class="h-icon" :style="{'background-image': 'url(pay-icons/7.png)'}"></i>
                  <i class="h-icon" :style="{'background-image': ' url(pay-icons/22.png)'}"></i>
                  <i class="h-icon" :style="{'background-image': ' url(pay-icons/10.png)'}"></i>
                  <i class="h-icon" :style="{'background-image': ' url(pay-icons/14.png)'}"></i>
                </div>

                <!-- <b-field label="Card Number" label-position="on-border">
                  <b-input placeholder="XXXX XXXX XXXX XXXX" v-cleave="masks.creditCard" required minlength="8" v-model="card.number"></b-input>
                </b-field> -->

              </div>

              <div class="column">
                <v-text-field
                          :rules="[v => !!v || 'CVC is required']"
                          :label="$t('booking.payment.cvc_label')"
                          type="number"
                          required
                          :placeholder="$t('booking.payment.cvc_placeholder')"
                          v-model="bookingContext.card.cvx">
                </v-text-field>
                <v-text-field
                          :rules="[v => !!v || 'Card Holder is required']"
                          :label="$t('booking.payment.card_holder_label')"
                          required
                          v-model="bookingContext.card.cardholder">
                </v-text-field>
              </div>
              <div class="column">
                <v-text-field
                          :rules="[v => !!v || 'Expiration is required']"
                          :label="$t('booking.payment.expiration_label')"
                          type="number"
                          required
                          v-model="bookingContext.card.expirationDate">
                </v-text-field>
              </div>

            </div>
            <div class="padding-comment">
              <v-textarea
                append-outer-icon="mdi-comment"
                class="mx-2"
                :label="$t('booking.payment.comment_label')"
                rows="2"
                cols="20"
                outlined
                v-model="bookingContext.card.note"
                :placeholder="$t('booking.payment.comment_placeholder')">
              </v-textarea>
              <!-- <b-field label="Comment/note" label-position="on-border">
                <b-input type="textarea" rows="2" cols="20" v-model="booking.card.note" placeholder="Comment for renter"></b-input>
              </b-field> -->
            </div>

            <div style="padding: 0.65rem 0.6rem;">
              <v-checkbox v-model="validateConditions" required>
            <template v-slot:label>
              <div>
                {{$t('booking.payment.cgu_check_label_1')}} ‘{{$t('booking.payment.book_button_label')}}’, {{$t('booking.payment.cgu_check_label_2')}}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <a target="_blank" :href="cguUrl" @click.stop v-on="on">{{$t('booking.payment.cgu_check_label_3')}}</a>
                  </template>
                  Opens in new window
                </v-tooltip>
                 {{$t('booking.payment.cgu_check_label_4')}}
                 <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <a target="_blank" :href="rentalUrl" @click.stop v-on="on">{{$t('booking.payment.cgu_check_label_5')}}</a>
                  </template>
                  Opens in new window
                </v-tooltip>
              </div>
            </template>
              </v-checkbox>
            </div>

            <AppAlert   :alert="error" />

            <v-btn color="primary"  type="submit" depressed solo :loading="isLoading">
              <v-icon class="mr-2">mdi-book</v-icon> {{$t('booking.payment.book_button_label')}}
              <span style="font-weight: 300;font-size: 1rem;padding-left: 0.8rem"> ({{ bookingContext.totalTTC | currency}})</span>
            </v-btn>

          </v-form>
      </v-col>
      <input id="cardType" style="display:none" />

    </v-row>
</v-container>

</template>

<script>



import {BookingHeader} from '../components';
import {BookingSteps} from "../models";
import {BookingService} from "../services";
import {LocationsApi} from "@/shared/services";

export default {
    name: 'BookingPaymentStep',
    props: {
        bookingContext: null
    },
    data() {
        return {
            cguUrl: "/p/api/v1/loc/cgu/driver",
            rentalUrl:  "/p/api/v1/loc/cgu/rental",
            validateConditions: true,
            creditCard: {
                creditCard: true,
            },
            isLoading: false,
            error: null
        };
    },
    methods: {
        validateAndSubmit() {

            this.error = null;
            try{

                // book
                this.isLoading = true;

            }catch(error){
                this.error = error;
            }
        }
    },
    components: {BookingHeader}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 960px) {
  .container {
    width: 66rem;
  }

  .padding-like-field {
    padding: 5.12rem 0 0 0;
  }

  .box {
    margin: 1rem 2rem !important;
  }

  .padding-comment {
    padding: 1rem 10rem!important;
  }
}
.padding-top{
  padding-top: 4rem;
}
.padding-comment {
  padding: 0.8rem;
}

.box {
  margin: 0.3rem;
}


</style>
